<template>
  <section class="content">
    <div class="row center-block">
      <div class="col-md-12">
        <meal-tag-form />
      </div>
    </div>
  </section>
</template>

<script>
import MealTagForm from './Temp/MealTagFormTemp.vue'

export default {
  name: 'Tables',
  components: {
    'meal-tag-form': MealTagForm
  },
  methods: {
  },
  computed: {
    checkInput () {
      return this.$parent.checkInput
    },
    getDataH () {
      return this.$parent.getDataH
    },
    getData () {
      return this.$parent.getData
    }
  }
}
</script>



// WEBPACK FOOTER //
// MealTagForm.vue?9b7a972a